import { useState, useEffect } from "react";
import clsx from 'clsx'
import { useIntl } from 'react-intl';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { IEvento } from "../../interfaces/IEvento";
import EventoService from "../../services/EventoService";
import Swal from 'sweetalert2';
import EventoModal from "./EventoModal";
import EventoTabela from "./EventoTabela";
import GrupoEventoService from "../../services/GrupoEventoService";
import { IGrupoEvento } from "../../interfaces/IGrupoEvento";
import RegimeTributarioService from "../../services/RegimeTributarioService";
/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';
interface MarcacaoRegimeTributario {
    id: number;
    nome: string;
    abreviacao?: string;
}

export const ListaMarcacaoRegimeTributario: MarcacaoRegimeTributario[] = [
    { id: 0, nome: 'Todos' },
    { id: 1, nome: 'Simples Nacional', abreviacao: 'SN' },
    { id: 2, nome: 'Lucro Presumido', abreviacao: 'LP' },
    { id: 3, nome: 'Lucro Real Estimativa Mensal', abreviacao: 'LREM' },
    { id: 4, nome: 'Lucro Real Trimestral', abreviacao: 'LRT' },
    { id: 5, nome: 'Lucro Arbitrado', abreviacao: 'LA' },
    { id: 6, nome: 'Lucro Imune', abreviacao: 'LI' }
];

function Evento() {
    const { t } = useTranslation();
    const intl = useIntl();
    const [eventos, setEventos] = useState<IEvento[]>([]);
    const [filtro, setFiltro] = useState<string>('');
    const [eventosExibicao, setEventosExibicao] = useState<IEvento[]>([]);
    const [grupoEventos, setGrupoEventos] = useState<IGrupoEvento[]>([]);
    const [filtroEvento, setFiltroEvento] = useState<number>(0);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [eventoVM, setEventoVM] = useState<IEvento | undefined>(undefined);
    const [modalTitle, setModalTitle] = useState<string>('');
    const [carregado, setCarregado] = useState<boolean>(false);
    const { classes } = useLayout();
    const columns = [
        {
            name: t('Nome do Evento'),
            selector: (row: IEvento) => row['nome'],
            sortable: true,
            wrap: true
        },
        {
            name: t('Conta Contábil Referencial'),
            selector: (row: IEvento) => row['contaReferencial'],
            sortable: true,
            wrap: true
        },
        {
            name: t('Regime Tribuário'),
            selector: (row: IEvento) => {
                const opcaoTodos = ListaMarcacaoRegimeTributario[0];
                const regimesTributarios = row['regimesTributarios'];
                const quantidadeRegimesTributarios = ListaMarcacaoRegimeTributario.filter(x => x.id !== opcaoTodos.id).length;

                if (regimesTributarios.length === quantidadeRegimesTributarios) {
                    const texto = opcaoTodos.nome;

                    return t(texto);
                }
                else {
                    const listaAbreviacoes = regimesTributarios.map(x => ListaMarcacaoRegimeTributario.find(p => x.regimeTributarioID === p.id)?.abreviacao);
                    const listaAbreviacoesOrdenadas = listaAbreviacoes.sort((a, b) => (a ?? "") > (b ?? "") ? 1 : -1);
                    const textoConcatenado = listaAbreviacoesOrdenadas.join(', ');

                    return textoConcatenado;
                }
            },
            sortable: true,
            wrap: true
        },
        {
            name: t('Ações'),
            cell: (row: IEvento) => <AcoesEventos excluirEvento={excluirEvento} editarEvento={(evento: IEvento) => {
                setModalTitle('Editar Evento');
                setEventoVM(evento);
                toggleModal();
            }} item={row} />,
            wrap: true
        }
    ];

    useEffect(() => {
        async function grupoEventosIniciar() {
            setGrupoEventos(await GrupoEventoService.obterTodos());
            await inicializar();
        }

        grupoEventosIniciar();
    }, []);

    function BotoesHeaderTabela() {
        return <>
            {
                grupoEventos.sort((a, b) => a.id > b.id ? 1 : -1).map((x, index) => <button key={index} onClick={() => filtrarEventos(x.id)} className={`btn btn-filtro ${x.id === filtroEvento && 'ativo'}`}>{t(x.nome)}</button>)
            }
        </>
    };

    function AcoesEventos({ item, excluirEvento, editarEvento }: { item: IEvento, excluirEvento: (evento: IEvento) => void, editarEvento: (Evento: IEvento) => void }) {
        return <div data-tag="allowRowEvents">
            <i onClick={() => editarEvento(item)} className="fas fa-edit fs-1" style={{ color: '#5E6397', fontWeight: 'normal', cursor: 'pointer' }} />
            <i onClick={() => excluirEvento(item)} className="fas fa-trash-alt fs-1" style={{ color: '#5E6397', marginLeft: '20px', fontWeight: 'normal', cursor: 'pointer' }} />
        </div>
    }

    async function filtrarEventos(filtroId: number) {
        let eventosFiltrados = filtroId === 0 ? eventos : eventos.filter(e => e.grupoEventoID === filtroId);

        setFiltroEvento(filtroId);
        setEventosExibicao(eventosFiltrados.sort((a, b) => a.nome > b.nome ? 1 : -1));
    }

    async function inicializar() {
        setCarregado(false);
        await EventoService.obterTodos(x => {
            setEventos(x);
            setEventosExibicao(x);
        });
        setCarregado(true);
    }

    function toggleModal(): void {
        setShowModal(!showModal);

        if (showModal) {
            setTimeout(() => {
                setEventoVM(undefined)
            }, 300)
        }
    }

    async function excluirEvento(evento: IEvento) {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-modal-excluir ms-5',
                cancelButton: 'btn btn-modal-cancelar'
            },
            buttonsStyling: false
        });
        const result = await swalWithBootstrapButtons.fire({
            title: t('Excluir Evento'),
            text: t(`Você realmente deseja excluir esse evento?`),
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: `Excluir`,
            reverseButtons: true
        });

        if (result.isConfirmed) {
            await EventoService.excluir(evento.id, inicializar, t('Evento excluído com sucesso'));
        }
    }

    async function funcaoSucesso() {
        toggleModal();
        await inicializar();
    }

    async function salvar(evento: IEvento) {
        if (evento.id !== undefined && evento.id !== null && evento.id > 0) {
            await EventoService.alterar(evento, funcaoSucesso, t('Evento foi editado com sucesso'));
        } else {
            await EventoService.adicionar(evento, funcaoSucesso, t('Evento foi adicionado com sucesso'));
        }
    }

    return <>
        <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.EVENTS' })}</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
                <input onChange={(e) => setFiltro(e.target.value)} placeholder="Buscar..." className="form-control" style={{ width: '50%' }} />
                <EventoModal salvar={salvar} evento={eventoVM} title={modalTitle} show={showModal} toggleModal={toggleModal} />
                <div className='d-flex align-items-center py-1'>
                    <button onClick={() => {
                        setModalTitle(t('Adicionar Evento'));
                        setEventoVM(undefined);
                        setShowModal(true);
                    }} className='btn btn-sm btn-primario'>
                        <i className="icon-lg text-white fas fa-plus"></i>
                        <span style={{ verticalAlign: 'middle' }}> {t("EVENTO")} </span>
                    </button>
                </div>
            </div>
        </div>

        {
            carregado ?
                <EventoTabela filtro={filtro} colunas={columns} itens={eventosExibicao} FiltroHeader={BotoesHeaderTabela} />
                :
                <p>{t("Carregando...")}</p>
        }
    </>
};

export default Evento;